import React from "react";
import styles from "./md-icon.scss";
export default function CreditCardCheck36(props) {
    return (
        <div className={styles.view + " " + styles.size36}><svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30 6H6a2.977 2.977 0 0 0-2.985 3L3 27c0 1.665 1.335 3 3 3h7.5v-3H6v-9h27V9c0-1.665-1.335-3-3-3Zm0 6H6V9h24v3Zm-7.605 16.755L18.15 24.51l-2.115 2.115L22.395 33 33 22.395l-2.115-2.115-8.49 8.475Z" fill={props.color || "#FFFFFF"}/></svg></div>
    );
};